// App.js
import React, { useState } from "react";
import "./Contact.css";
import contactImage from "./icons/contact.jpg";
import Header from "./Header";
import Footer from "./Footer";
import { toast, Toaster } from "react-hot-toast";

function App() {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    companyName: "",
    message: "", // Message field add panni irukken
    serviceRequired: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    const data = new FormData(event.target);
    data.append("access_key", "3004e08f-44e2-4ec0-bc99-e8ca974488ba");
    data.append(
      "subject",
      `New enquiry: ${formData.serviceRequired || "General"}`,
    );

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: data,
      });

      const result = await response.json();

      if (result.success) {
        toast.success("Message sent successfully! ✅");
        event.target.reset();
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          companyName: "",
          message: "",
          serviceRequired: "",
        });
      } else {
        toast.error("Failed to send message! ❌");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const faqs = [
    {
      question: "What services does Alvanium provide?",
      answer:
        "We provide workflow solutions, customization services, Android application development, and business productivity solutions.",
    },
    {
      question: "Can Alvanium customize existing platforms?",
      answer:
        "Yes, we customize Jira, Confluence, Jira Service Management, Zendesk, monday.com, and related business workflows.",
    },
    {
      question: "Can I request a custom solution?",
      answer:
        "Yes, we provide customized solutions based on specific business requirements.",
    },
    {
      question: "How long does project delivery usually take?",
      answer:
        "Project timelines vary depending on requirements, complexity, and customization scope.",
    },
  ];

  return (
    <div className="app">
      <Header />
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="main-heading">
              <span className="title-black">Let's Connect And Build</span>{" "}
              <br />
              <span className="title-blue">Smarter Apps Together</span>
            </h1>
            <p className="sub-heading">
              Have questions, need support, or looking for customized solutions?
              Our team is here to help you find the right solution for your
              business.
            </p>
            <p className="short-description">
              Whether you are looking for workflow solutions, platform
              customization, Android application development, or business
              support, we would love to hear from you.
            </p>
          </div>
          <div className="hero-image">
            <div className="illustration-wrapper">
              <img
                src={contactImage}
                alt="Contact Us Illustration"
                className="contact-image"
              />
              <div className="floating-element elem1"></div>
              <div className="floating-element elem2"></div>
              <div className="floating-element elem3"></div>
              <div className="floating-element elem4"></div>
              <div className="floating-element elem5"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Get In Touch Section */}
      <section className="get-in-touch-section">
        <div className="section-header">
          <h2 className="section-heading">
            <span className="title-black">Get In</span>
            <span className="title-blue">Touch</span>
          </h2>
          <p className="section-description">
            Reach out to us for inquiries, consultations, support, or project
            discussions. Our team is ready to assist you with solutions tailored
            to your business needs.
          </p>
        </div>

        <div className="contact-cards-grid">
          {/* Email Card */}
          <div className="contact-card-item">
            <div className="card-header">
              <div className="card-icon">✉</div>
              <h3 className="card-title">Email Us</h3>
            </div>
            <p className="card-description">
              Send us your questions and business inquiries.
            </p>
            <a
              href="mailto:info@alvanium.com"
              className="card-value email-link"
            >
              info@alvanium.com
            </a>
          </div>

          {/* Business Hours Card */}
          <div className="contact-card-item">
            <div className="card-header">
              <div className="card-icon">🕐</div>
              <h3 className="card-title">Business Hours</h3>
            </div>
            <p className="card-description">Our team is ready to assist you.</p>
            <div className="business-hours-detail">
              <div className="hour-row">
                <span>Monday – Friday (IST)</span>
                <span className="time-value">9:30 AM – 6:30 PM</span>
              </div>
              <div className="hour-row closed">
                <span>Saturday & Sunday</span>
                <span className="time-value closed-text">Closed</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ///contact form/// */}
      <section>
        <div className="modern-contact-wrapper">
          <Toaster position="top-center" />
          <div className="modern-contact-container">
            {/* Left Side: Brand Info & Message */}
            <div className="contact-info-side">
              <span className="badge">Get in Touch</span>
              <h2>Send Us A Message</h2>
              <p className="description">
                Fill out the form below and our team will get back to you as
                soon as possible.
              </p>

              <div className="response-box">
                <div className="dot-indicator"></div>
                <div>
                  <strong>Quick Response</strong>
                  <p>
                    Our team typically responds within 24–48 business hours.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Side: Form Card */}
            <div className="contact-form-side">
              <form onSubmit={handleSubmit} className="modern-form">
                <div className="input-field">
                  <label htmlFor="fullName">Full Name</label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    required
                    placeholder="Type Your Name..."
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                </div>

                <div className="input-field">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    placeholder="alex@company.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-row-2col">
                  <div className="input-field">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="+91 000000-0000"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-field">
                    <label htmlFor="companyName">Company Name</label>
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      placeholder="Type Your Company Name...."
                      value={formData.companyName}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="input-field">
                  <label htmlFor="serviceRequired">Service Required</label>
                  <div className="select-wrapper">
                    <select
                      id="serviceRequired"
                      name="serviceRequired"
                      required
                      value={formData.serviceRequired}
                      onChange={handleChange}
                      className="custom-select"
                    >
                      <option value="" disabled>
                        Select a service required...
                      </option>
                      <option value="Jira App Development">
                        Jira App Development
                      </option>
                      <option value="Confluence App Development">
                        Confluence App Development
                      </option>
                      {/* Long option text-a label or option display-la safe-a handle panrom */}
                      <option value="Jira Service Management App Development">
                        Jira Service Mgmt App Dev
                      </option>
                      <option value="Zendesk App Development">
                        Zendesk App Development
                      </option>
                      <option value="monday.com App Development">
                        monday.com App Development
                      </option>
                      <option value="Android App Development">
                        Android App Development
                      </option>
                      <option value="Custom App Development">
                        Custom App Development
                      </option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="input-field">
                  <label htmlFor="message">Message</label>
                  <textarea
                    className="textera"
                    id="message"
                    name="message"
                    rows="4"
                    required
                    placeholder="Type your message here..."
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="blue-submit-btn"
                  disabled={submitting}
                >
                  {submitting ? "Sending..." : "Send Message ➔"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="faq-header">
          <h2 className="section-heading">
            <span className="title-black">Frequently Asked</span>
            <span className="title-blue">Questions</span>
          </h2>
          <p className="section-description">
            Find answers to the most commonly asked questions about our
            services.
          </p>
        </div>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              className={`faq-item ${activeFAQ === index ? "active" : ""}`}
              key={index}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <span className="faq-question-text">{faq.question}</span>
                <span className="faq-icon">
                  {activeFAQ === index ? "−" : "+"}
                </span>
              </div>
              <div
                className={`faq-answer ${activeFAQ === index ? "active" : ""}`}
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="cta-section  cta-contact">
        <div className="cta-content">
          <h2>
            Ready To Get <span>Started</span>?
          </h2>
          <p>
            Let's work together to build smarter Apps.bbbbb
            <br />
            Improve your business experience.
          </p>
          {/* <div className="cta-buttons">
            <button className="cta-btn primary-btn">Contact Us</button>
          </div> */}
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default App;
